import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import moment from 'moment';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { addLocaleFormatToMoment } from '@config/global-constants';
import { PreferencesService } from '@shared/services';

import {
    set_company_preferences,
    set_company_preferences_failure,
    set_company_preferences_success,
} from '../actions/company.action';

@Injectable()
export class CompanyEffects {
    getCompanyPreferences$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(set_company_preferences),
            mergeMap(({ id }) =>
                this.preferencesService.getCompanyPreferences(id).pipe(
                    tap((preferences) => {
                        const percentageOptions = {
                            ...preferences.currencyAndNumbers,
                            symbol: '%',
                            symbolPositioning: 'right',
                        };
                        addLocaleFormatToMoment(moment.localeData(preferences.dateAndTime.locale).longDateFormat('L'));
                        this.preferencesService.setCompanyPreferences({ ...preferences, percentageOptions });
                    }),
                    map((preferences) => {
                        const percentageOptions = {
                            ...preferences.currencyAndNumbers,
                            symbol: '%',
                            symbolPositioning: 'right',
                        };
                        return set_company_preferences_success({
                            preferences: { ...preferences, percentageOptions },
                        });
                    }),
                    catchError(async () => {
                        return set_company_preferences_failure();
                    }),
                ),
            ),
            catchError(async () => set_company_preferences_failure),
        );
    });

    setCompanyPreferencesFailure$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(set_company_preferences_failure),
                tap(() => {
                    this.router.navigate(['/pages/error-page'], { queryParams: { type: 'no-company-data' } }).catch();
                }),
            );
        },
        { dispatch: false },
    );

    constructor(
        private preferencesService: PreferencesService,
        private actions$: Actions,
        private router: Router,
    ) {}
}
